<template>
  <div>
    <BusinessEntityInput
      v-model="companyName"
      :error="errorCompanyName"
      :label="$t('Registered company name')"
      name="company_name"
      :placeholder="$t('Registered company name')"
      required
      @focusout="v$.companyName.$touch"
    />

    <CompanyNumberInput class="tw-mt-4" market="AU">
      <BusinessEntityInput
        v-model="companyNo"
        :error="errorCompanyNo"
        label=""
        placeholder="51 824 753 556"
        name="company_no"
        @focusout="v$.companyNo.$touch"
      />
    </CompanyNumberInput>

    <BusinessEntityVat
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="{}"
      market="AU"
      class="tw-mt-5"
    />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { computed, ref } from 'vue'
import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import BusinessEntityVat from '@/components/compliances/BusinessEntity/BusinessEntityVat.vue'
import CompanyNumberInput from '@/components/compliances/BusinessEntity/CompanyNumberInput.vue'
import {
  commonCompanyName,
  commonCompanyNumber,
} from '@/components/compliances/BusinessEntity/Validations/BusinessEntityValidationRules'
import { useValidatorWithGraphQlError } from '@/composables/errors'

export default {
  components: {
    BusinessEntityInput,
    BusinessEntityVat,
    CompanyNumberInput,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    errorsGraphql: {
      type: Object,
      default() {
        return null
      },
    },
  },
  emits: ['update:businessEntity'],
  setup(props, { emit }) {
    const v$ = useVuelidate()
    const errors = ref(props.errorsGraphql)

    const internalBusinessEntity = ref(props.businessEntity)

    const companyName = computed({
      get() {
        return internalBusinessEntity.value.companyName
      },
      set(value) {
        internalBusinessEntity.value.companyName = value
        v$.value.companyName.$touch()
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })
    const errorCompanyName = useValidatorWithGraphQlError(
      v$,
      errors,
      'companyName',
      'registered_company_name',
    )

    const companyNo = computed({
      get() {
        return internalBusinessEntity.value.companyNo
      },
      set(value) {
        internalBusinessEntity.value.companyNo = value
        v$.value.companyNo.$touch()
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })
    const errorCompanyNo = useValidatorWithGraphQlError(v$, errors, 'companyNo', 'company_no')

    const isVatRegistered = computed({
      get() {
        return (
          internalBusinessEntity.value.data?.is_vat_registered ||
          (internalBusinessEntity.value.taxNo !== null && internalBusinessEntity.value.taxNo !== '')
        )
      },
      set(value) {
        internalBusinessEntity.value.isVatRegistered = value
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })

    const vatNo = computed({
      get() {
        return internalBusinessEntity.value.taxNo
      },
      set(value) {
        internalBusinessEntity.value.taxNo = value
        v$.value.vatNo.$touch()
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })
    const errorVatNo = useValidatorWithGraphQlError(v$, errors, 'vatNo', 'vat_no')

    return {
      companyName,
      companyNo,
      isVatRegistered,
      vatNo,
      errorCompanyName,
      errorCompanyNo,
      errorVatNo,
      internalBusinessEntity,
      v$,
    }
  },

  validations() {
    return {
      companyName: commonCompanyName(),
      companyNo: commonCompanyNumber(),
      vatNo: {},
    }
  },
}
</script>
